<template>
  <div>
    <page-header
      :page="page"
      :actions="headerActionConfig"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <filter-manager
      ref="filter"
      v-model="filter.model"
      :filters="filtersHeader"
      @search="searchHandler"
      @academicYear="onAcademicYearChange"
      @status="onStatusChange"
      @center="onCenterChange"
      @municipality="onMunicipalityChange"
      @school="onSchoolChange"
      @type="onTypeChange"
      class="filter-manager_extended"
      search-container-class="search-btn"
    />
    <div class="row my-3 mx-0">
      <div class="col-12">
        <custom-separator text="Resultados" />
      </div>
    </div>

    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />

    <section v-if="result" class="mt-4 mx-0">
      <div v-if="is12b">
        <saee12b-row
          v-for="(item, index) in result"
          :key="`${item.id}-${index}`"
          :item="item"
          class="mb-4"
          :index="index"
          :active-index="activeIndex"
          :academic-year-id="filter.model.academicYear.id"
          @refreshSearchResults="refreshSearchResults"
        />
      </div>
      <div v-if="is12 || is12a">
        <saee12-row
          v-for="(item, index) in result"
          :key="`${item.id}-${index}`"
          :item="item"
          class="mb-4"
          :index="index"
          :active-index="activeIndex"
          :type="filter.model?.type"
          @refreshSearchResults="refreshSearchResults"
        />
      </div>
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </section>
  </div>
</template>

<script>
import FilterManager from 'FilterManager';
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import CustomSeparator from 'custom-separator';
import academicYearService from '@/services/academicyear';
import { getTransitionStatuses } from '@/modules/common/code.api';
import locationServices from '@/services/api/location.api';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import * as locationAlternativeApi from '@/views/pei/location-alternatives/_api';
import transitionStudentService from '@/services/pei/transitionStudent.js';
import moment from 'moment';
import mixAlert from '@/mixin/alert.mixin';
import storeMixin from '@/mixin/storeGenerator';
import { transitionStudentTypes } from '@/utils/constants/pei/transition-student/transitionStudentTypes';
import Saee12bRow from './components/Saee12bRow';
import Saee12Row from './components/Saee12Row';
import CustomResultNotFound from 'custom-result-not-found';
import userRole from '@/utils/constants/userRoles';
import reportService from '@/services/report';
import schoolTypes from '@/utils/constants/student/schoolTypes.js';

const ROUTE_NAME_ADD_ACTIVITY = 'transition-student-12b';
const ROUTE_NAME_ADD_SAEE_12 = 'transition-student-saee-12-add';
const MODULE_NAME = 'TransitionStudent';

export default {
  components: {
    FilterManager,
    PageHeader,
    Pagination,
    CustomSeparator,
    Saee12Row,
    Saee12bRow,
    CustomResultNotFound,
  },
  mixins: [mixAlert, storeMixin],
  data: () => ({
    moduleName: MODULE_NAME,
    filter: {},
    page: {
      icon: 'fas fa-user-edit',
      title: 'Proceso de transición postescolar',
      routes: ['Inicio', 'PEI', 'Perfil del estudiante en transición'],
    },
    results: [],
    filter: {
      model: {
        academicYear: null,
        provider: null,
        status: null,
        sie: null,
        center: null,
        municipality: null,
        school: null,
        teacher: null,
        type: transitionStudentTypes.Saee12B,
      },
      options: {
        academicYears: [],
        providers: [],
        statuses: [],
        centers: [],
        municipalities: [],
        schools: [],
        teachers: [],
        types: [],
      },
    },
    result: [],
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 10,
    },
    isWeek30InRange: false,
    activeIndex: null,
    sysParameters: [],
  }),
  computed: {
    filtersHeader() {
      return [
        {
          name: 'type',
          inputName: 'type',
          component: 'CustomToggle',
          options: this.filter.options.types,
          value: this.filter.model.type,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
        },
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filter.options.academicYears,
          value: this.filter.model.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: false,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          error: 'El año académico es requerido.',
          validations: 'required',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
          mapParentValue: this.filter.model.status == null,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          value: this.filter.model.sie,
          placeholder: 'Escriba Nombre de Estudiante o SIE',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md-3',
          type: 'text',
        },
        {
          name: 'center',
          label: 'Centro:',
          component: 'CustomDropDown',
          options: this.filter.options.centers,
          value: this.filter.model.center,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.center == null,
          isAdvanced: true,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          options: this.filter.options.municipalities,
          value: this.filter.model.municipality,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.municipality == null,
          isAdvanced: true,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          options: this.filter.options.schools,
          value: this.filter.model.school,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.school == null,
          isAdvanced: true,
        },
        {
          name: 'teacher',
          label: 'Maestro:',
          component: 'CustomDropDown',
          options: this.filter.options.teachers,
          value: this.filter.model.teacher,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.teacher == null,
          isAdvanced: true,
          disabled: this.filter.options.teachers.length == 1 && this.isTeacher,
        },
      ];
    },
    headerActionConfig() {
      return [
        {
          text: 'Añadir Actividad',
          icon: 'fas fa-file-plus',
          variant: 'success',
          visible: this.filter.model.type == transitionStudentTypes.Saee12B,
          click: () => this.handlerAddActivity(),
        },
        {
          text: 'Añadir SAEE-12',
          icon: 'fas fa-file-plus',
          variant: 'success',
          visible: this.filter.model.type == transitionStudentTypes.Saee12,
          click: () => this.handlerAddSAEE12(),
        },
        {
          text: 'Imprimir',
          icon: 'fas fa-print',
          variant: 'success',
          visible: this.filter.model.type == transitionStudentTypes.Saee12B,
          click: () => this.print(),
        },
      ];
    },
    isTeacher() {
      return this.userRole === userRole.maestro;
    },
    showNotResults() {
      return this.result.length == 0;
    },
    is12b() {
      return this.filter.model.type == transitionStudentTypes.Saee12B;
    },
    is12a() {
      return this.filter.model.type == transitionStudentTypes.Saee12A;
    },
    is12() {
      return this.filter.model.type == transitionStudentTypes.Saee12;
    },
  },
  mounted() {
    Promise.all([
      this.getAcademicYears(),
      this.getStatuses(),
      this.getCenters(),
    ]);
  },
  methods: {
    async onPageChange(page, validate = true) {
      this.search(this.filter.model, page, validate);
      this.activeIndex = null;
    },
    async getSysParam() {
      const { data: sysParameters } = await getSysparameterByNames({
        academicYearId: this.filter.model.academicYear?.id,
        parameterNames: ['ProgressReportEducationalServicesWeek30'],
      });

      this.sysParameters = sysParameters;

      const week30Date = (
        sysParameters.find(
          (x) => x.name === 'ProgressReportEducationalServicesWeek30'
        ) || {}
      ).effectiveDate;

      this.isWeek30InRange = moment().isAfter(week30Date);

      this.getTypes();
    },
    getTypes() {
      this.filter.options.types = [
        {
          text: '12b',
          value: transitionStudentTypes.Saee12B,
          checked: this.filter.model.type == transitionStudentTypes.Saee12B,
        },
        {
          text: '12a',
          value: transitionStudentTypes.Saee12A,
          disabled: !this.isWeek30InRange,
          checked: this.filter.model.type == transitionStudentTypes.Saee12A,
        },
        {
          text: '12',
          value: transitionStudentTypes.Saee12,
          disabled: !this.isWeek30InRange,
          checked: this.filter.model.type == transitionStudentTypes.Saee12,
        },
      ];
    },
    async search(filters, page = 1, validate = true) {
      const isValid = validate
        ? await this.$refs.filter.$refs.formValidator.validate()
        : true;
      if (!isValid) return;

      try {
        const {
          academicYear,
          status,
          sie,
          center,
          municipality,
          school,
          teacher,
        } = filters;

        const mappedFilter = {
          academicYearId: (academicYear || {}).id,
          status: (status || {}).id,
          centerId: (center || {}).id,
          municipalityId: (municipality || {}).id,
          StudentSieId: this.isASie(sie),
          firstName:
            isNaN(sie) && (typeof sie === 'string' || sie instanceof String)
              ? sie
              : null,
          schoolId: (school || {}).id,
          teacherId: (teacher || {}).id,
          pageIndex: page,
          pageSize: 10,
        };

        mappedFilter.type = this.filter.model.type;

        const service = this.is12b
          ? transitionStudentService.getActivities(mappedFilter)
          : transitionStudentService.getAllSAEE12(mappedFilter);
        const result = (await service).data;

        this.result = result.data.map((x) => ({ ...x, isOpen: false }));
        this.pagination = {
          ...this.pagination,
          totalItemCount: result.totalItemCount,
          pageCount: result.pageCount,
          currentPage: result.currentPage,
          count: result.count,
        };
      } catch (error) {
        this.ShowToast(error.message, '', 'error');
      }
    },
    async searchHandler(filters) {
      await this.search(filters);
      this.activeIndex = null;
    },
    async refreshSearchResults() {
      await this.search(this.filter.model);
      this.activeIndex = null;
    },
    async getStatuses() {
      const statuses = (await getTransitionStatuses()).data;
      this.filter.options.statuses = statuses;
    },
    async onAcademicYearChange(value) {
      this.filter.model.center = null;
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        centers: [],
        municipalities: [],
        schools: [],
        teachers: [],
      };

      if (!value) return;
      this.getSysParam();
      await this.getCenters();
    },
    async onStatusChange(value) {
      this.filter.model.status = value;
    },
    async onCenterChange(value) {
      this.filter.model.municipality = null;
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        municipalities: [],
        schools: [],
        teachers: [],
      };

      if (!value) return;

      await this.getMunicipalities();
    },
    async onMunicipalityChange(value) {
      this.filter.model.school = null;
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        schools: [],
        teachers: [],
      };

      if (!value) return;

      await this.getSchools();
    },
    async onSchoolChange(value) {
      this.filter.model.teacher = null;

      this.filter.options = {
        ...this.filter.options,
        teachers: [],
      };

      if (!value) return;

      await this.getTeachers();
    },
    async onTypeChange() {
      this.search(this.filter.model, 1, true);
    },
    async getAcademicYears() {
      const {
        data: academicYearsList,
      } = await academicYearService.getAcademicYearFromMin({
        minYearId: 27,
        yearType: 'CURRENT',
      });
      this.filter.options.academicYears = academicYearsList;
      this.filter.model.academicYear = this.currentAcademicYear();
      this.getSysParam();
    },
    async getCenters() {
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      locationServices
        .getCenters({ academicYearId: academicYearId })
        .then(({ data }) => {
          this.filter.options.centers = data;

          if (data.length == 1) {
            this.filter.model.center = data[0];
            this.getMunicipalities();
          }
        });
    },
    async getMunicipalities() {
      const centerId = (this.filter.model.center || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (centerId) {
        locationServices
          .getMunicipalities({ academicYearId, centerId })
          .then(({ data }) => {
            this.filter.options.municipalities = data;

            if (data.length == 1) {
              this.filter.model.municipality = data[0];
              this.getSchools();
            }
          });
      }
    },
    async getSchools() {
      const municipalityId = (this.filter.model.municipality || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (municipalityId) {
        locationServices
          .getSchools({ academicYearId, municipalityId })
          .then(({ data }) => {
            this.filter.options.schools = data;

            if (data.length == 1) {
              this.filter.model.school = data[0];
              this.getTeachers();
            }
          });
      }
    },
    async getTeachers() {
      const schoolId = (this.filter.model.school || {}).id;
      const academicYearId = this.filter.model.academicYear?.id ?? 0;

      if (schoolId) {
        locationAlternativeApi
          .getTeachersBySchool(academicYearId, schoolId)
          .then((data) => {
            this.filter.options.teachers = data;
            if (data.length == 1 && this.isTeacher) {
              this.filter.model.teacher = data[0];
            }
          });
      }
    },
    isASie(sie) {
      return sie
        ? /^\s*[0-9]{8}\s*$/.test(sie)
          ? sie.replace(/\s+/g, '')
          : null
        : null;
    },
    handlerAddActivity() {
      this.$router.push({
        name: ROUTE_NAME_ADD_ACTIVITY,
        params: {
          academicYearId: this.filter.model.academicYear.id,
        },
      });
    },
    async print() {
      let schoolNotRequiredSieAndTeacher = [
        schoolTypes.Institutions,
        schoolTypes.PrivateSchool,
        schoolTypes.YoungInstitutions,
      ];
      if (
        !schoolNotRequiredSieAndTeacher.includes(
          this.filter.model.school?.type
        ) &&
        !this.filter.model.sie &&
        !this.filter.model.teacher?.id
      ) {
        this.ShowToast(
          'Es requerido al menos un estudiante o un maestro en la búsqueda',
          '',
          'error'
        );
        return;
      }

      await reportService.downloadSaee12b({
        academicYearId: this.filter.model.academicYear?.id,
        studentSieId: this.filter.model.sie,
        teacherId: this.filter.model.teacher?.id,
        centerId: this.filter.model.center?.id,
        municipalityId: this.filter.model.municipality?.id,
        schoolId: this.filter.model.school?.id,
      });
    },
    handlerAddSAEE12() {
      this.$router.push({
        name: ROUTE_NAME_ADD_SAEE_12,
      });
    },
  },
  destroyed() {
    this.persistData();
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .filter-manager_extended {
    border-radius: 0.25rem;
    @media only screen and (min-width: 750px) {
      .search-btn {
        &.col-lg-3 {
          flex: 0 0 10%;
          max-width: 10%;
          padding-left: 0;
        }
      }
    }
  }
}
</style>
